// Device-local preferences (localStorage, never synced). Shared settings live in the API.
import type { Destination } from "@desk/contracts";

export type OpenTo = "today" | "inbox" | "last";
export type WeekStart = "system" | "sunday" | "monday";
export type TimeFormat = "system" | "12h" | "24h";
/** Where quick add files a task when it opens outside a container. */
export type CaptureDefault = { kind: "inbox" } | { kind: "last" } | { kind: "pinned"; dest: Destination };

export const PREF = {
  openTo: "prefs.openTo",
  weekStart: "prefs.weekStart",
  timeFormat: "prefs.timeFormat",
  captureDefault: "prefs.captureDefault",
  /** Last destination chosen in quick add (for `captureDefault: last`). */
  captureLast: "capture.lastDest",
  /** Hash of the last list or screen viewed (for `openTo: last`). */
  lastRoute: "nav.lastRoute",
  /** Scroll offsets of recently viewed lists, by route path. */
  scroll: "nav.scroll",
} as const;

export const DEFAULTS = {
  openTo: "today" as OpenTo,
  weekStart: "system" as WeekStart,
  timeFormat: "system" as TimeFormat,
  captureDefault: { kind: "inbox" } as CaptureDefault,
};
